// Length limits for user, group, and supplier names.
// Mirrors qerchabackend/utils/nameLimits.js; the server is the source of truth.
export const NAME_LIMITS = {
  username: { min: 3, max: 30 },
  groupName: { min: 3, max: 40 },
  supplierName: { min: 2, max: 100 },
  supplierDisplayName: { min: 0, max: 40 },
  shortDescription: { min: 0, max: 200 },
};
